
export { HorizontalProductCardSkeleton } from "/codebuild/output/src1758541852/src/packages/shared-components/src/components/ProductCard/index.ts"
export { VerticalProductCardSkeleton } from "/codebuild/output/src1758541852/src/packages/shared-components/src/components/ProductCard/index.ts"